import { Image } from '@chakra-ui/react';

import { ThemeIcon, ThemeIconProps } from '../../components';
import DarkLogo from './assets/blast_icon_dark.svg';
import LightLogo from './assets/blast_icon_light.svg';

function LightIcon(): JSX.Element {
  return <Image alt="blast light icon" height="60px" maxH="100%" src={LightLogo} />;
}

function DarkIcon(): JSX.Element {
  return <Image alt="blast dark icon" height="60px" maxH="100%" src={DarkLogo} />;
}

export function Icon({ ...props }: ThemeIconProps): JSX.Element {
  return <ThemeIcon darkIcon={<DarkIcon />} lightIcon={<LightIcon />} {...props} />;
}
